import { map } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ITableEvent, ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { documents_table_keys, IDocumentModule, IDocumentsModulesResponse } from './documents.constants';
import { DocumentsService } from './documents.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { AlertService } from 'src/app/components/alert/alert.service';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent implements OnInit, OnDestroy {

  athoraDocuments: IDocumentModule[] = [];
  isvDocuments: IDocumentModule[] = [];
  previdenzaDocuments: IDocumentModule[] = [];
  tableKeys: ITableKey[] = CommonUtils.assign(documents_table_keys);
  documentConfigs: any[] = [];
  destroy$ = new Subject<void>(); 

  constructor(
    private _documentsService: DocumentsService,
    private _spinnerService: SpinnerService,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.retrieveDocuments();
  }

  retrieveDocuments(): void {
    this._spinnerService.show();
    this._documentsService.retrieveDocuments()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: IDocumentsModulesResponse) => {
          LoggerService.logInfo(this.constructor.name, 'retrieveDocuments', response);
          if (response) {
            this.manageDocuments(response);
          }
          this._spinnerService.hide();
        },
        error: (error) => {
          LoggerService.logError(this.constructor.name, 'retrieveDocuments', error);
          this._alertService.openErrorMessage('Errore nel recupero dei template', 'retrieveDocuments', error);
          this._spinnerService.hide();
        }
      });
  }

  manageDocuments(response: IDocumentsModulesResponse): void {
    this.athoraDocuments = this.sortManualsFirst(response.athoraFiles);
    this.isvDocuments = this.sortManualsFirst(response.intesaFiles);
    this.previdenzaDocuments = this.sortManualsFirst(response.previdenzaFiles)
    this.documentConfigs = [
      {
          logo: 'assets/images/athora_logo_full.png',
          documents: this.athoraDocuments
      },
      {
          logo: 'assets/images/isv_logo_full.png',
          documents: this.isvDocuments
      },
      {
          logo: 'assets/images/isp_logo_full.png',
          documents: this.previdenzaDocuments
      },
    ];
  }

  sortManualsFirst(files: IDocumentModule[]): IDocumentModule[] {
    return files.sort((a, b) => {
        const aIsDocx = a.name.toLowerCase().endsWith(".docx");
        const bIsDocx = b.name.toLowerCase().endsWith(".docx");

        if (aIsDocx && !bIsDocx) return -1;
        if (!aIsDocx && bIsDocx) return 1;
        return a.name.localeCompare(b.name);
    });
  }

  onActionRequested(document: IDocumentModule): void {
    LoggerService.logInfo(this.constructor.name, 'onActionRequested', event);
    if (document?.preSignedUrl) {
      this.downloadDocument(document.preSignedUrl, document.name);      
    }
  }

  downloadDocument(url: string, name: string): void {
    LoggerService.logInfo(this.constructor.name, 'downloadDocument', url);
    this._spinnerService.show();
    this._documentsService.downloadDocument(url)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: Blob) => {
          LoggerService.logInfo(this.constructor.name, 'downloadDocument', { response });
          if (response) {
            this.manageDownloadedDoc(response, name);
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'downloadDocument', { error });
          this._alertService.openErrorMessage('Errore durante il download del documento', 'downloadDocument', error);
          this._spinnerService.hide();
        }
      })
  }

  manageDownloadedDoc(blob: Blob, name: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
